import { useService } from 'react-reservice';

import { getUseServiceWithSubscriptionKeys } from '@webtrader/core/utils';

import authService from './service';

export const useAuth = () => {
  return useService(authService, (state) => state);
};

export const useAuthWithKeys = getUseServiceWithSubscriptionKeys(authService);

export { authService };
